import { render, staticRenderFns } from "./LeadProjectDetails.vue?vue&type=template&id=13f1f3da"
import script from "./LeadProjectDetails.vue?vue&type=script&lang=ts"
export * from "./LeadProjectDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports